import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatomoService } from './services/matomo/matomo.service';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  constructor(
    translate: TranslateService,
    private readonly matomo: MatomoService,
  ) {
    translate.setDefaultLang('de');
    translate.use('de');
  }

  ngOnInit(): void {
    // DOCU-1035: lädt nur den Tracker. Die Seitenaufrufe melden die einzelnen
    // Seiten selbst — die Registrierung schrittweise, damit der Trichter
    // sichtbar wird.
    this.matomo.init();
  }
}
